import React from 'react'
import * as classes from './Shares.module.scss'
import Container from '../../../ui/Container/Container'
import SectionTitle from '../../../ui/SectionTitle/SectionTitle'
import { deleteHtmlTag } from '../../../../utils/deleteHtmlTag'

function Shares({ data, lang }) {
    const title = data?.shares?.value ? deleteHtmlTag(data.shares.value, 'p') : ''
    const photoUrl = data?.shares?.photo?.url
    const photoAlt = data?.shares?.photo?.alt || title

    if (!title && !photoUrl) {
        return null
    }

    return (
        <section className={classes.Section}>
            <Container>
                <div className={classes.LineWrap}>
                    <div className={classes.Line}/>
                </div>
                {title ? <SectionTitle title={title} lang={lang} /> : null}

                {photoUrl ? (
                    <div className={classes.ImageWrap}>
                        <img className={classes.Image} src={photoUrl} alt={photoAlt} />
                    </div>
                ) : null}
            </Container>
        </section>
    )
}

export default Shares
